import routes from './routes';
import httpClient, { isHttpError } from '../httpClient';

export async function getAllProaqItens() {
  try {
    const response = await httpClient.get(routes.proaqitem);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao obter lista de Itens.',
      );
    }
    throw error;
  }
}

export async function getItensByProaqId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaqitem/proaq/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getProdutosByProaqId(id: string) {
  try {
    const response = await httpClient.get(
      `/api/proaqitem/proaq/${id}/produtos`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Produtos do Proaq: ' + error);
  }
}

export async function getProaqItem(id: string) {
  try {
    const response = await httpClient.get(`${routes.proaqitem}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export const createProaqItem = async (data: any): Promise<any> => {
  try {
    const response = await httpClient.post(routes.proaqitem, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao criar o item do PROAQ.',
      );
    }
    throw error;
  }
};

export const updateProaqItem = async (id: string, data: any): Promise<any> => {
  try {
    const response = await httpClient.patch(`${routes.proaqitem}/${id}`, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar o item do PROAQ.',
      );
    }
    throw error;
  }
};

export const deleteProaqItem = async (id: string): Promise<any> => {
  const response = await httpClient.delete(`${routes.proaqitem}/${id}`);
  return response.data;
};

export const getKitPorComponente = async (
  componenteNumber: number,
): Promise<any> => {
  try {
    const url = routes.kitporcomponete.replace(
      ':componenteNumber',
      componenteNumber.toString(),
    );
    const response = await httpClient.get(url);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao obter kits por componente.',
      );
    }
    throw error;
  }
};

export const getDenominacoesPorComponente = async (
  componenteLabel: string,
): Promise<any> => {
  try {
    const url = routes.denomicacoesporcomponente.replace(
      ':componenteLabel',
      componenteLabel.toString(),
    );
    const response = await httpClient.get(url);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message ||
          'Erro ao obter denominações por componente.',
      );
    }
    throw error;
  }
};
